import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import AuthService from '../../../services/auth.service';
export const recovery = createAsyncThunk('auth/forgot-password', async (email) => {
    try {
        return await AuthService.recoveryPassword(email);
    }
    catch (err) {
        return err.response;
    }
});
export const recoveryConfirm = createAsyncThunk('auth/confirm-reset-password', async (attr) => {
    try {
        return await AuthService.confirmRecoveryPassword(attr.token, attr.password);
    }
    catch (err) {
        return err.response;
    }
});
export const initialState = {
    waitingForConfirmation: false,
    readyToLogin: false,
    email: '',
    error: null,
    pending: false
};
export const passwordRecoverySlice = createSlice({
    name: 'passwordRecovery',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
            state.waitingForConfirmation = false;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(recovery.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.waitingForConfirmation = true;
                state.pending = false;
            }
            else {
                state.waitingForConfirmation = false;
                state.pending = false;
                state.error = action.payload.data.error;
            }
        });
        builder.addCase(recovery.rejected, (state, action) => {
            state.pending = false;
            state.waitingForConfirmation = false;
        });
        builder.addCase(recovery.pending, (state) => {
            state.pending = true;
            state.error = '';
        });
        builder.addCase(recoveryConfirm.fulfilled, (state, action) => {
            state.pending = false;
            if (action.payload.status === 200) {
                state.readyToLogin = true;
            }
            else {
                state.error = action.payload.data.error;
                state.readyToLogin = false;
            }
        });
        builder.addCase(recoveryConfirm.rejected, (state, action) => {
            state.pending = false;
            state.readyToLogin = false;
        });
        builder.addCase(recoveryConfirm.pending, (state) => {
            state.error = '';
            state.pending = true;
            state.readyToLogin = false;
        });
    }
});
export const { clearError } = passwordRecoverySlice.actions;
export default passwordRecoverySlice.reducer;
